import {
  AsyncActionState,
  asyncActionStateMatchers,
  setupSlice,
  invoke,
} from '@owl-frontend/redux';
import { runs as runsApi } from '../../api/runs/client';
import type { Run } from '../../api/runs/interface';

export interface RunState {
  runs: {
    [dossier_id: string]: Run[];
  };
  selected_runs: {
    [dossier_id: string]: Run | null;
  };
  actions: {
    runs: AsyncActionState;
  };
}

const initialState: RunState = {
  runs: {},
  selected_runs: {},
  actions: {
    runs: { status: 'uninitialized' },
  },
};

const slice = setupSlice('runs', initialState)
  .addAsyncSagas({
    runs: invoke(runsApi),
  })
  .addReducers({
    'runs/fulfilled': (state, action) => {
      state.runs[action.meta.arg] = action.payload;
    },
  })
  .addReducers({
    setSelectedRun: (
      state,
      action: { payload: { dossier_id: string; run: Run | null } }
    ) => {
      state.selected_runs[action.payload.dossier_id] = action.payload.run;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
